import { useSettingsStore } from "@/data/settingsStore";

export const COMMERCIAL_MODE_ENABLED_KEY = "kaynin_commercial_mode_enabled";
export function isCommercialModeEnabled() {
  return useSettingsStore.getState().getSetting(COMMERCIAL_MODE_ENABLED_KEY, true) as boolean;
}
export function setCommercialModeEnabled(enabled: boolean) {
  useSettingsStore.getState().updateSetting(COMMERCIAL_MODE_ENABLED_KEY, enabled);
}

export const PARTY_LIKES_ENABLED_KEY = "kaynin_party_likes_enabled";
export function isPartyLikesEnabled() {
  return useSettingsStore.getState().getSetting(PARTY_LIKES_ENABLED_KEY, true) as boolean;
}
export function setPartyLikesEnabled(enabled: boolean) {
  useSettingsStore.getState().updateSetting(PARTY_LIKES_ENABLED_KEY, enabled);
}

export const EVENT_LIKES_ENABLED_KEY = "kaynin_event_likes_enabled";
export function isEventLikesEnabled() {
  return useSettingsStore.getState().getSetting(EVENT_LIKES_ENABLED_KEY, true) as boolean;
}
export function setEventLikesEnabled(enabled: boolean) {
  useSettingsStore.getState().updateSetting(EVENT_LIKES_ENABLED_KEY, enabled);
}
